import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.product.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_PRODUCT_ASYNC: `${uid}.saveProductAsync`,
    SAVE_PRODUCT_SUCCESS: `${uid}.saveProductSuccess`,
    SAVE_PRODUCT_FAILURE: `${uid}.saveProductFailure`,
    CREATE_PRODUCT: `${uid}.createProduct`
};

export { ActionTypes };
